import React from "react";

import { ChevronDown, ChevronUp } from "lucide-react";

import { RadioGroupItem } from "~/components/ui/radio-group";
import { Separator } from "~/components/ui/separator";
import SalesRequestItemsList, {
  SalesRequestItem,
} from "~/pages/payments/components/SalesRequestItemsList";
import { formatCurrency, formatDate } from "~/utils/helpers";

export interface SalesRequestCardProps {
  id: string;
  createdAt: string;
  totalAmount: number;
  paidAmount: number;
  items: SalesRequestItem[];
  isSelected: boolean;
  isExpanded: boolean;
  onSelect: () => void;
  onToggleExpand: () => void;
}

const SalesRequestCard: React.FC<SalesRequestCardProps> = ({
  id,
  createdAt,
  totalAmount,
  paidAmount = 0,
  items,
  isSelected,
  isExpanded,
  onSelect,
  onToggleExpand,
}) => {
  const isPaidPartially = paidAmount > 0 && paidAmount < totalAmount;
  const remainingAmount = totalAmount - paidAmount;

  return (
    <div className="overflow-hidden rounded-lg border">
      <div
        className={`cursor-pointer p-4 ${isSelected ? "bg-gray-50 dark:bg-gray-900" : ""}`}
        onClick={onSelect}
      >
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-x-2">
            <RadioGroupItem value={id} id={id} />
            <div>
              <div className="font-medium">{formatDate(createdAt)}</div>
              <div className="text-sm text-muted-foreground">
                Total: {formatCurrency(totalAmount)}
                {isPaidPartially && (
                  <span className="ml-2 text-yellow-600">
                    (Pagado: {formatCurrency(paidAmount)})
                  </span>
                )}
              </div>
              {isPaidPartially && (
                <div className="text-xs text-muted-foreground">
                  Pendiente: {formatCurrency(remainingAmount)}
                </div>
              )}
            </div>
          </div>
          <button
            type="button"
            className="rounded-md text-gray-400 hover:text-gray-500 focus:outline-none"
            onClick={(e) => {
              e.stopPropagation();
              onToggleExpand();
            }}
          >
            {isExpanded ? (
              <ChevronUp className="h-4 w-4" />
            ) : (
              <ChevronDown className="h-4 w-4" />
            )}
          </button>
        </div>
      </div>

      {isExpanded && (
        <div className="px-4 pb-4 pt-0">
          <Separator className="my-2" />
          <SalesRequestItemsList
            items={items}
            paidAmount={paidAmount}
            totalAmount={totalAmount}
          />
        </div>
      )}
    </div>
  );
};

export default SalesRequestCard;
